// Front/src/hooks/useTranslate.js

import translations from '../i18n/translations';
import { useLanguageContext } from '../context/LanguageContext';

export const useTranslate = () => {
  const { language } = useLanguageContext();
  const t = translations[language];

  return t;
};
